import type { SortingState } from '@tanstack/react-table'
import type { ObjectValues } from '~/@lib/utils/type.utils'
import type { ProjectsItem } from '../_project_types/project.types'

const TABS = {
  ALL: 0,
  SHORTEST_PERIOD: 1,
  HIGHEST_YELD: 2,
  RECOMMENDED: 3,
} as const

type TABS = ObjectValues<typeof TABS>

const sortingBySelectedTab: Record<number, SortingState> = {
  [TABS.SHORTEST_PERIOD]: [{ desc: false, id: 'investmentPeriod' }],
  [TABS.HIGHEST_YELD]: [{ desc: true, id: 'interestRate' }],
}

function projectsFilteredForCurrentTab(
  selectedTab: number,
  projects: Array<ProjectsItem>
) {
  if (selectedTab === TABS.RECOMMENDED)
    return projects.filter((project) => project.recommended)

  if (
    selectedTab === TABS.ALL ||
    selectedTab === TABS.SHORTEST_PERIOD ||
    selectedTab === TABS.HIGHEST_YELD
  )
    return projects

  return []
}

export { TABS, sortingBySelectedTab, projectsFilteredForCurrentTab }
